"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _appointment = _interopRequireDefault(require("../../components/softBusinessLogistics/appointment.vue"));
var _footNav = _interopRequireDefault(require("../../components/foot-nav"));
var _topNav = _interopRequireDefault(require("../../components/top-nav.vue"));
var _default = exports.default = {
  components: {
    appointment: _appointment.default,
    footNav: _footNav.default,
    topNav: _topNav.default
  },
  data: function data() {
    return {
      navItems: ['千城联盟', '联盟介绍', '剑指"四座大山"', '联盟赋能', '联盟入驻', '联盟案例'],
      currentSection: 0,
      isManualScrolling: false,
      // 增加一个"手动跳转中"的锁，防止点击导航时乱跳
      // 新增：记录当前选中的功能模块索引
      activeFeature: 0,
      dialogVisible: false // 控制弹窗显示隐藏
    };
  },
  mounted: function mounted() {
    // 监听父容器的滚动事件
    var parent = this.$el.parentElement;
    if (parent) {
      parent.addEventListener('scroll', this.handleParentScroll);
    }
  },
  beforeDestroy: function beforeDestroy() {
    var parent = this.$el.parentElement;
    if (parent) {
      parent.removeEventListener('scroll', this.handleParentScroll);
    }
  },
  methods: {
    //立即体验
    TryNow: function TryNow() {
      this.dialogVisible = true;
    },
    // 监听父容器滚动
    handleParentScroll: function handleParentScroll(e) {
      this.handleScroll(e);
    },
    // 滚动监听
    handleScroll: function handleScroll(e) {
      // 如果正在执行点击跳转的平滑滚动，直接拦截，不执行逻辑
      if (this.isManualScrolling) return;
      var target = e.target;
      var scrollTop = target.scrollTop;
      var clientHeight = target.clientHeight;
      var scrollHeight = target.scrollHeight;

      // 核心计算：总共能滚动的最大距离
      var maxScroll = scrollHeight - clientHeight;

      // 如果内容还没到需要滚动的程度，直接返回
      if (maxScroll <= 0) return;

      // 计算当前滚动的百分比 (0 - 100)
      var progress = scrollTop / maxScroll * 100;
      var activeIndex = 0;
      console.log(progress, "progressprogress");
      // 根据你要求的百分比阈值进行判断
      // 注意：这里的逻辑是"大于某比例就切换到下一项"
      if (progress >= 80) {
        activeIndex = 5;
      } else if (progress >= 60) {
        activeIndex = 4;
      } else if (progress >= 38) {
        activeIndex = 3;
      } else if (progress >= 22) {
        activeIndex = 2;
      } else if (progress >= 7) {
        activeIndex = 1;
      } else {
        activeIndex = 0;
      }

      // 只有索引变动时才更新视图，性能最优
      if (this.currentSection !== activeIndex) {
        console.log("\u5F53\u524D\u8FDB\u5EA6\uFF1A".concat(progress.toFixed(2), "%\uFF0C\u5207\u6362\u5230\u7D22\u5F15\uFF1A").concat(activeIndex));
        this.currentSection = activeIndex;
      }
    },
    // 点击导航平滑跳转
    scrollToSection: function scrollToSection(index) {
      var _this = this;
      var sections = document.querySelectorAll('.section');
      if (sections[index]) {
        // 1. 开启防跳锁
        this.isManualScrolling = true;
        this.currentSection = index;

        // 2. 执行平滑滚动
        sections[index].scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

        // 3. 延迟 800 毫秒（等待滚动动画结束）后再解开锁
        setTimeout(function () {
          _this.isManualScrolling = false;
        }, 800);
      }
    }
  }
};